import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utilities';

const initialState = {
  orders: null,
  nextOrderID: null,
  orderSending: false,
  ordersLoading: true,
  errorMessage: null
}

const getOrders = (state, action) => {
  const orders = action.orders;
  return updateObject(state, { orders: orders });
}

const addOrder = (state, action) => {
  const updatedOrders = state.orders.concat(action.order);
  return updateObject(state, { orders: updatedOrders });
}

const toggleOrderSending = (state) => {
  return updateObject(state, { orderSending: !state.orderSending });
}

const toggleOrdersLoading = (state) => {
  return updateObject(state, { ordersLoading: !state.ordersLoading })
}

const displayFormError = (state, action) => {
  return updateObject(state, { errorMessage: action.error })
}

const setNextID = (state, action) => {
  return updateObject(state, { nextOrderID: action.nextID });
}

const ordersReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_ORDERS: return getOrders(state, action);
    case actionTypes.TOGGLE_ORDERS_LOADING: return toggleOrdersLoading(state);
    case actionTypes.TOGGLE_ORDER_SENDING: return toggleOrderSending(state);
    case actionTypes.ADD_ORDER: return addOrder(state, action);
    case actionTypes.DISPLAY_FORM_ERROR: return displayFormError(state, action);
    case actionTypes.SET_NEXT_ID: return setNextID(state, action);
    default: return state;
  }
}

export default ordersReducer;


// WEBPACK FOOTER //
// ./src/store/reducers/ordersReducer.jsx